export const countryCode = {
  CN: "中国",
  KR: "韓国",
  RU: "ロシア",
};
